import { render } from "./AnalysisDeliveryDemograPage.vue?vue&type=template&id=5a615d63"
import script from "./AnalysisDeliveryDemograPage.vue?vue&type=script&lang=js"
export * from "./AnalysisDeliveryDemograPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__